import * as Types from '../../../../graphql-types'

import { gql } from '@apollo/client'
import { ContentFeatureMediaFragmentFragmentDoc } from '../../../../services/yi/queries/ContentFeatureMediaFragment.generated'
import { ContentDetails_Tag_ContentReferenceFragmentFragmentDoc } from '../../../../services/yi/queries/ContentDetailsTagContentReferenceFragment.generated'
import { ContentDetails_Person_ContentReferenceFragmentFragmentDoc } from '../../../../services/yi/queries/ContentDetailsPersonContentReferenceFragment.generated'
export type YiClass_ContentFragmentFragment = {
  __typename?: 'Content'
  descriptionFormat?: string | null
  shortDescriptionFormat?: string | null
  displayType?: string | null
  primaryLanguage?: string | null
  productType?: string | null
  seoDescription?: string | null
  seoTitle?: string | null
  contentPolicyPolicyId?: number | null
  featureMediaId?: string | null
  yiContentType?: Array<{
    __typename?: 'ContentReference'
    id?: string | null
    sortKey?: number | null
    contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
    contentTo?: Array<{
      __typename?: 'Content'
      id?: string | null
      titleGroupId?: string | null
      title?: string | null
      contentId?: number | null
      contentType?: string | null
      published?: boolean | null
    } | null> | null
  } | null> | null
  yiTags?: Array<{
    __typename?: 'ContentReference'
    id?: string | null
    sortKey?: number | null
    contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
    contentTo?: Array<{
      __typename?: 'Content'
      id?: string | null
      titleGroupId?: string | null
      title?: string | null
      contentId?: number | null
      contentType?: string | null
      published?: boolean | null
    } | null> | null
  } | null> | null
  yiYogaStyle?: Array<{
    __typename?: 'ContentReference'
    id?: string | null
    sortKey?: number | null
    contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
    contentTo?: Array<{
      __typename?: 'Content'
      id?: string | null
      titleGroupId?: string | null
      title?: string | null
      contentId?: number | null
      contentType?: string | null
      published?: boolean | null
    } | null> | null
  } | null> | null
  yiYogaLevel?: Array<{
    __typename?: 'ContentReference'
    id?: string | null
    sortKey?: number | null
    contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
    contentTo?: Array<{
      __typename?: 'Content'
      id?: string | null
      titleGroupId?: string | null
      title?: string | null
      contentId?: number | null
      contentType?: string | null
      published?: boolean | null
    } | null> | null
  } | null> | null
  yiYogaTeacher?: Array<{
    __typename?: 'ContentReference'
    id?: string | null
    sortKey?: number | null
    contentReferenceType?: {
      __typename?: 'ContentReferenceType'
      id?: string | null
      type?: string | null
    } | null
    contentTo?: Array<{
      __typename?: 'Content'
      id?: string | null
      title?: string | null
      language?: string | null
      contentType?: string | null
      contentId?: number | null
      published?: boolean | null
      avatar?: Array<{
        __typename?: 'ImageContentRelationship'
        id?: string | null
        type?: string | null
        image?: { __typename?: 'Image'; id?: string | null; url?: string | null } | null
      } | null> | null
    } | null> | null
  } | null> | null
  yiPracticeType?: Array<{
    __typename?: 'ContentReference'
    id?: string | null
    sortKey?: number | null
    contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
    contentTo?: Array<{
      __typename?: 'Content'
      id?: string | null
      titleGroupId?: string | null
      title?: string | null
      contentId?: number | null
      contentType?: string | null
      published?: boolean | null
    } | null> | null
  } | null> | null
  featureMedia?: {
    __typename?: 'Media'
    mediaId?: string | null
    contentId?: string | null
    mediaMaestroTitleCode?: string | null
    policyId?: number | null
    updatedAt?: any | null
    duration?: number | null
    isPublished?: boolean | null
    mediaAssets?: Array<{
      __typename?: 'MediaAsset'
      id?: string | null
      providerKey?: string | null
    } | null> | null
  } | null
}

export const YiClass_ContentFragmentFragmentDoc = gql`
  fragment YIClass_ContentFragment on Content {
    descriptionFormat
    shortDescriptionFormat
    displayType
    primaryLanguage
    productType
    seoDescription
    seoTitle
    ...ContentFeatureMediaFragment
    yiContentType: contentReferencesFrom(types: "yi-content-type") {
      ...ContentDetails_Tag_ContentReferenceFragment
    }
    yiTags: contentReferencesFrom(types: "yi-tag") {
      ...ContentDetails_Tag_ContentReferenceFragment
    }
    yiYogaStyle: contentReferencesFrom(types: "yi-yoga-style") {
      ...ContentDetails_Tag_ContentReferenceFragment
    }
    yiYogaLevel: contentReferencesFrom(types: "yi-yoga-level") {
      ...ContentDetails_Tag_ContentReferenceFragment
    }
    yiYogaTeacher: contentReferencesFrom(types: "yi-yoga-teacher") {
      ...ContentDetails_Person_ContentReferenceFragment
    }
    yiPracticeType: contentReferencesFrom(types: "yi-practice-type") {
      ...ContentDetails_Tag_ContentReferenceFragment
    }
  }
  ${ContentFeatureMediaFragmentFragmentDoc}
  ${ContentDetails_Tag_ContentReferenceFragmentFragmentDoc}
  ${ContentDetails_Person_ContentReferenceFragmentFragmentDoc}
`
